/* @flow */

import React from 'react';
import styled from 'styled-components';

import WorldInfo from './WorldInfo';

const Desktop = styled.div`
  @media (max-width: 700px) {
    display: none;
  }
`;
const Mobile = styled.div`
  @media (min-width: 700px) {
    display: none;
  }
`;

const Row = styled.div`
  margin: 20px;
`;

const Box = styled.div`
  padding: 1rem;
  border: 1px solid var(--foreground);
`;
const Title = styled.h1`
  margin-bottom: 0px;
`;
const Subtitle = styled.div`
  font-style: italic;
  & a {
    color: lightblue;
  }
`;

const SectionTitle = styled.h3`
  text-decoration: underline;
`;

const WorldRow = styled.div`
  display: flex;
  justify-content: center;
`;

const WorldTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 300px;
  font-size: 20px;
  text-transform: uppercase;
`;

const WorldLevels = styled.div`
  flex: 1;
  text-align: left;
  margin: 10px;
`;

const LevelButton = styled.span`
  padding: 5px;
  margin: 5px;
  border: 2px solid white;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    color: black;
    background-color: white;
  }
`;

type Props = {
  loaded: boolean,
  clickLevel: string => void,
};
type State = {};

export default class Menu extends React.Component<Props, State> {
  render() {
    const { loaded } = this.props;
    if (!loaded) {
      return <div>loading, please wait...</div>;
    }

    const worldInfo = WorldInfo.getWorldAsObject();

    return (
      <div>
        <Box>
          <Row>
            <Title>musicboy</Title>
            <Subtitle>
              an unfinished physics-based puzzle game with a musical twist
              <br />
              made by <a href="https://www.mpaulweeks.com">mpaulweeks</a>
            </Subtitle>
          </Row>
        </Box>
        <Desktop>
          <Row>
            <SectionTitle>instructions</SectionTitle>
          </Row>
          <Row>
            use [left/right] arrow keys to move
            <br />
            use [A] to jump
            <br />
            use [S] to grab/release umbrellas (they light up when you're close enough to grab one)
            <br />
            use [up/down] arrow keys to adjust a grabbed umbrella
          </Row>
          <Row>
            <SectionTitle>choose a level by clicking below</SectionTitle>
          </Row>
          {worldInfo.map(world => (
            <WorldRow key={'world-' + world.name}>
              <WorldTitle>{world.name}</WorldTitle>
              <WorldLevels>
                {world.levels.map(level => (
                  <LevelButton
                    key={`world-${world.name}-level-${level.key}`}
                    onClick={() => this.props.clickLevel(level.key)}
                  >
                    {level.name}
                  </LevelButton>
                ))}
              </WorldLevels>
            </WorldRow>
          ))}
        </Desktop>
        <Mobile>
          <Row>this game requires a wide display + keyboard</Row>
        </Mobile>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Menu.js